export function getEnv(str){
    if (typeof window !== "undefined"){
      return window.ENV[str];
    }
    return process.env[str];
  }
  